/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SellerName
 */
export interface SellerName {
}

/**
 * Check if a given object implements the SellerName interface.
 */
export function instanceOfSellerName(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SellerNameFromJSON(json: any): SellerName {
    return SellerNameFromJSONTyped(json, false);
}

export function SellerNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): SellerName {
    return json;
}

export function SellerNameToJSON(value?: SellerName | null): any {
    return value;
}

